import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconOffersFlame = (props: IconProps) => {
  const { size = 30, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 30 30"
      color={color ?? '#C40000'}
      {...otherProps}
    >
      <Path
        fill="currentColor"
        d="M17.0372 28.7032C21.8181 27.7697 28 24.4158 28 15.7441C28 7.85374 22.0766 2.59849 17.8172 0.184119C16.8705 -0.35274 15.7647 0.352633 15.7647 1.41889V4.14494C15.7647 6.29536 14.8379 10.2204 12.2624 11.8533C10.9471 12.687 9.52471 11.4388 9.36565 9.91766L9.23412 8.66797C9.08118 7.21547 7.564 6.33413 6.37412 7.21995C4.23447 8.80815 2 11.5968 2 15.7426C2 26.347 10.0891 29 14.1328 29C14.3694 29 14.6161 28.9925 14.8731 28.9776C12.8756 28.8121 9.64706 27.6042 9.64706 23.697C9.64706 20.6399 11.9335 18.5745 13.6709 17.5679C14.1389 17.2995 14.6849 17.6499 14.6849 18.1793V19.0592C14.6849 19.7302 14.9526 20.7816 15.5873 21.5004C16.3061 22.3146 17.3599 21.4616 17.444 20.3909C17.4715 20.0538 17.8202 19.8391 18.12 20.0091C19.1004 20.5683 20.3529 21.7614 20.3529 23.697C20.3529 26.7512 18.6262 28.1559 17.0372 28.7032Z"
      />
    </Svg>
  );
};
